var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"initialValue":_vm.mInitialValue,"init":_vm.editorOptions,"disabled":_vm.disabled,"outputFormat":_vm.outputFormat},on:{"onInit":_vm.onInit}})
}
var staticRenderFns = []

export { render, staticRenderFns }